import { useContext, createContext } from "react";
import { baseURL } from "../lib";
import { useAuth } from "./AuthContext";
import axios from 'axios'

const ReportContext = createContext()

const ReportProvider = ({ children }) => {

    const { auth, toast } = useAuth();

    const headers = {
        Authorization: auth?.token,
    };

    const discountReportPDF = async (reportDetail) => {
        const { filter, startDate, endDate } = reportDetail;

        try {
            const { data } = await axios.get(`${baseURL}/admin/report/discount/pdf?filter=${filter}&startDate=${startDate}&endDate=${endDate}`, { headers })
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const discountReportCSV = async (reportDetail) => {
        const { filter, startDate, endDate } = reportDetail;

        try {
            const { data } = await axios.get(`${baseURL}/admin/report/discount/csv?filter=${filter}&startDate=${startDate}&endDate=${endDate}`, { headers })
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const serviceReportPDF = async (reportDetail) => {
        const { filter, startDate, endDate } = reportDetail;

        try {
            const { data } = await axios.get(`${baseURL}/admin/report/service/pdf?filter=${filter}&startDate=${startDate}&endDate=${endDate}`, { headers })
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const serviceReportCSV = async (reportDetail) => {
        const { filter, startDate, endDate } = reportDetail;

        try {
            const { data } = await axios.get(`${baseURL}/admin/report/service/csv?filter=${filter}&startDate=${startDate}&endDate=${endDate}`, { headers })
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    const memberLockReportCSV = async (reportDetail) => {
        const { filter, startDate, endDate, memberGroupId } = reportDetail;

        try {
            const { data } = await axios.get(`${baseURL}/admin/report/member/lock/entries/csv?filter=${filter}&startDate=${startDate}&endDate=${endDate}&memberGroupId=${memberGroupId}`, { headers })
            if (data.error === false) {
                toast({ title: data.message, position: 'top', status: 'success', isClosable: true });
                return data
            } else {
                toast({ title: data.message, position: 'top', status: 'error', isClosable: true });
            }
        } catch (error) {
            toast({ title: error?.response?.data?.message, position: 'top', status: 'error', isClosable: true })
        }
    }

    return (
        <ReportContext.Provider value={{ serviceReportPDF, serviceReportCSV, discountReportCSV, discountReportPDF, memberLockReportCSV }}>
            {children}
        </ReportContext.Provider>
    )
}

const useReport = () => useContext(ReportContext)

export { useReport, ReportProvider }